export class BlockedUserAuthAttemptError extends Error {
  public constructor() {
    super()

    this.message = 'errors.blockedUserAuthAttempt'
  }
}
